const StoreMaintain = () => import(/* webpackChunkName: "StoreMaintain" */ '@/views/StoreMaintain')
const WorkItem = () => import(/* webpackChunkName: "workItem" */ '@/views/StoreMaintain/workItem')
const StoreMappingDetail = () => import(/* webpackChunkName: "StoreMappingDetail" */ '@/views/StoreMaintain/storeMappingDetail')
const StoreMaintainSearch = () => import(/* webpackChunkName: "StoreMaintainSearch" */ '@/views/Search/storeMaintainSearch')
const StoreMaintainVisit = () => import(/* webpackChunkName: "StoreMaintainVisit" */ '@/views/StoreMaintain/storeVisit')
const StoreMaintainVisitDetail = () => import(/* webpackChunkName: "StoreMaintainVisitDetail" */ '@/views/StoreMaintain/storeVisitDetail')
const ReOrderVisit = () => import(/* webpackChunkName: "ReOrderVisit" */ '@/views/StoreMaintain/reOrderVisit')
const ReOrderVisitDetail = () => import(/* webpackChunkName: "ReOrderVisitDetail" */ '@/views/StoreMaintain/reOrderVisitDetail')
const storeMaintainRouter = [
  {
    // path: '', 或者 重定向
    path: '/storeMaintain',
    component: StoreMaintain,
    meta: { // 给路由对象添加额外的信息
      scrollY: 0,
      title: 'Store Maintain'
    }
  },
  {
    path: '/storeMaintain/workItem',
    component: WorkItem,
    meta: {
      title: 'Work Item'
    }
  },
  {
    path: '/storeMaintain/storeMappingDetail',
    component: StoreMappingDetail,
    meta: {
      title: 'Store info'
    }
  },
  {
    path: '/storeMaintain/search',
    component: StoreMaintainSearch,
    meta: {
      title: 'Store Maintain Search'
    }
  },
  {
    path: '/storeMaintain/storeVisit',
    component: StoreMaintainVisit,
    meta: {
      title: 'Store Maintain Visit'
    }
  },
  {
    path: '/storeMaintain/storeVisitDetail',
    component: StoreMaintainVisitDetail,
    meta: {
      title: 'Store Maintain Visit Detail'
    }
  },
  {
    path: '/storeMaintain/reOrderVisit',
    component: ReOrderVisit,
    meta: {
      title: 'ReOrder Visit'
    }
  },
  {
    path: '/storeMaintain/reOrderVisitDetail',
    component: ReOrderVisitDetail,
    meta: {
      title: 'ReOrder Visit Detail'
    }
  }
]

export default storeMaintainRouter
